import Cookie from 'js-cookie';

/**
 * 设置 Cookie
 * @param {String} name Cookie 键
 * @param {String} value Cookie 值
 * @param {Object} options Cookie 选项
 */
export function setCookie(name, value, options) {
  Cookie.set(name, value, options);
}

/**
 * 获取 Cookie
 * @param {String} name Cookie 键
 * @param {Object} options Cookie 选项
 */
export function getCookie(name, options) {
  return Cookie.get(name, options);
}

/**
 * 删除 Cookie
 * @param {String} name Cookie 键
 * @param {Object} options Cookie 选项
 */
export function removeCookie(name, options={}) {
  Cookie.remove(name, options);
}
